import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { AccountSettingsFacade } from './+state';
import { AccountSettingsStateModule } from './+state/account-settings.state.module';

import {
  AccountSettingsService
} from './services';

@NgModule({
  imports: [CommonModule, AccountSettingsStateModule],
})
export class DomainAccountSettingsModule {
  public static forRoot(): ModuleWithProviders {
    return {
      ngModule: DomainAccountSettingsModule,
      providers: [
        AccountSettingsService,
        AccountSettingsFacade
      ],
    };
  }
}
